import React, { useState, useEffect } from 'react';
import './EmployeeTransfer.css';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from "react-router-dom";
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { capitalizeFirstLetter } from '../../../utils/validations';
import { getDistrict } from '../../../services/monthlyAttendanceService';
import { getEmployyesforTransfor } from '../../../services/transport';
import { format } from 'date-fns';
import { getAuditLog } from '../../../utils/calculateDaysInMonthUtils';

const EmployeeTransfer = () => {
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [employeeName, setEmployeeName] = useState(null);
    const [designation, setDesignation] = useState("");
    const [draftId, setDraftId] = useState("");
    const [presentState, setPresentState] = useState("");
    const [presentDistrict, setPresentDistrict] = useState("");
    const [presentLocation, setPresentLocation] = useState("");
    const [fromDate, setFromDate] = useState(null);

    const [isFocused, setIsFocused] = useState({
        employeeName: false,
        reportingTo: false,
        fromDate: false
    });

    const [postingState, setPostingState] = useState(null);
    const [postingDistrict, setPostingDistrict] = useState(null);
    const [postingBlock, setPostingBlock] = useState(null);
    const [reportingTo, setReportingTo] = useState(null);
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [blockOptions, setBlockOptions] = useState([]);
    const [reportingOptions, setReportingOptions] = useState([]);
    const [errors, setErrors] = useState({});
    const [postingDesignation, setPostingDesignation] = useState(null);
    const [toLocation, setToLocation] = useState(null);
    const [designationOptions, setDesignationOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [remarks, setRemarks] = useState("");

    const [desginationsForEmployees, setDesignationForEmployees] = useState([]);
    const [seletedDesignation, setSelectedDesignation] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("success"); // success | error
    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const response = await getEmployyesforTransfor(state, district, seletedDesignation);
                const data = response.data;

                if (Array.isArray(data)) {
                    setEmployees(
                        data.map((item) => ({
                            value: item.employeeUniqueId,               // or item.postingId if needed
                            label: `${item.fullName} - ${item.contactNumber}`,
                            designation: item.designation || "",
                            presentState: item.stateName || "",
                            presentDistrict: item.districtName || "",
                            // We'll compute presentLocation dynamically later
                            workLocations: item.workLocations || [],
                            godowns: item.godowns || [],
                            draftId: item.employeeId,                    // assuming draftId is employeeId
                            raw: item
                        }))
                    );
                }
            } catch (error) {
                console.error("Error fetching employees:", error);
                setErrors(prev => ({ ...prev, general: "Error fetching employees" }));
            }
        };

        if (district) {
            fetchEmployees();
        } else {
            setEmployees([]);
        }
    }, [district, state, seletedDesignation]); // Keep state if filtering by state too
    useEffect(() => {

        const fetchStates = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                setStateOptions(res.data.map(item => ({
                    value: item.id,
                    label: capitalizeFirstLetter(item.stateName)
                })));
            } catch (err) {
                setErrors(prev => ({ ...prev, general: "Failed to load states" }));
            }
        };


        fetchStates();
    }, []);
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);

    useEffect(() => {
        if (postingState) {
            const fetchDistricts = async () => {
                try {
                    const res = await axios.get(
                        `${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${postingState}`
                    );
                    setDistrictOptions(res.data.map(item => ({
                        value: item.districtId,
                        label: item.districtName
                    })));
                } catch (err) {
                    setErrors(prev => ({ ...prev, general: "Failed to load districts" }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setPostingDistrict(null);
        }
    }, [postingState]);



    useEffect(() => {
        const fetchDesignationForEmployyes = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/designations/dropdown`);
                const options = response.data.map(item => ({
                    value: item.id,
                    label: item.designationName,
                    shortName: item.designationShortName,
                }));
                setDesignationForEmployees(options);
            }
            catch (error) {
                console.log("Get all Designations before fetching ");
            }
        };
        fetchDesignationForEmployyes();
    }, [])

    useEffect(() => {
        const fetchDesignations = async () => {
            const selectedObj = desginationsForEmployees.find(
                (item) => item.value === seletedDesignation
            );

            if (selectedObj && selectedObj.shortName) {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_API_BASE_URL}/api/designations/dropdown/by-designation?shortName=${selectedObj.shortName}`
                    );
                    const options = response.data.map(item => ({
                        value: item.id,
                        label: item.designationName,
                        // Use the specific shortName for THIS item (e.g., CMR_DEO)
                        shortName: item.designationShortName
                    }));
                    setDesignationOptions(options);
                } catch (error) {
                    console.error('Error fetching designations:', error);
                }
            } else {
                setDesignationOptions([]);
            }
        };
        fetchDesignations();
    }, [seletedDesignation, desginationsForEmployees]);

    useEffect(() => {
        if (postingDistrict) {
            const fetchLocation = async () => {
                try {
                    const res = await axios.get(
                        `${process.env.REACT_APP_API_BASE_URL}/api/locations/dropdown/by-district/${postingDistrict}`
                    );
                    setLocationOptions(res.data.map(item => ({
                        value: item.id,
                        label: item.name,
                        type: item.type // Store the type (TPDS or DHQ)
                    })));
                } catch (err) {
                    console.error('Error fetching locations:', err);
                    setErrors(prev => ({ ...prev, general: 'Failed to load locations' }));
                }
            };
            fetchLocation();
        }
    }, [postingDistrict]);

    // Add this logic inside your component render or right before the return
    const getFilteredLocations = () => {
        const selectedPosting = designationOptions.find(opt => opt.value === postingDesignation);

        if (!selectedPosting) return locationOptions;

        // Use the shortName we stored in the fetchDesignations effect
        const sName = selectedPosting.shortName?.toUpperCase() || "";

        // Group definitions
        const dhqDesignations = ["CRO", "ITM_TPDS", "ITM_PPC", "HDO", "HDOP", "PMDC", "SYSTEM_ADMIN", "APM", "CCO",];
        const cmrDesignations = ["CMR_DEO", "CMR"];
        const tpdsDesignations = ["DEO", "FCI_DEO", "TPDS"];

        console.log("Filtering for Designation ShortName:", sName);

        // 1. Logic for DHQ
        if (dhqDesignations.includes(sName)) {
            return locationOptions.filter(loc => loc.type === "DHQ");
        }

        // 2. Logic for CMR (Now explicitly checks CMR_DEO)
        if (cmrDesignations.includes(sName)) {
            return locationOptions.filter(loc => loc.type === "CMR");
        }

        // 3. Logic for TPDS
        if (tpdsDesignations.includes(sName)) {
            return locationOptions.filter(loc => loc.type === "TPDS");
        }

        // 4. Fallback: Show everything except DHQ if no specific match is found
        return locationOptions.filter(loc => loc.type !== "DHQ");
    };


    useEffect(() => {
        if (postingDistrict) {

            const fetchManagers = async () => {
                const selectedObj = desginationsForEmployees.find(
                    (item) => item.value === seletedDesignation
                );
                if (selectedObj && selectedObj.shortName) {
                    try {
                        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/list/reporting?districtId=${postingDistrict}&designation=${selectedObj.shortName}`);
                        setReportingOptions(res.data.map(item => ({
                            value: item.employeeloginId,
                            label: item.fullName,
                        })));
                    } catch (err) {
                        console.error('Error fetching managers:', err);
                        setErrors(prev => ({ ...prev, general: 'Failed to load reporting managers' }));
                    }

                }



            };
            fetchManagers();
        }
        else {
            console.log("Select the district for employyes")
        }
    }, [postingDistrict, seletedDesignation, desginationsForEmployees]);

    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;

        switch (field) {
            case "employeeName":
                setEmployeeName(selectedOption ? selectedOption.value : null);
                if (selectedOption) {
                    setDesignation(selectedOption.designation || "");
                    setDraftId(selectedOption.draftId || "");
                    setPresentState(selectedOption.presentState || "");
                    setPresentDistrict(selectedOption.presentDistrict || "");

                    // New logic for presentLocation
                    const locations = selectedOption.workLocations;
                    const godowns = selectedOption.godowns;

                    let locationDisplay = "";
                    if (Array.isArray(locations) && locations.length > 0) {
                        locationDisplay = locations.join(", ");
                    } else if (Array.isArray(godowns) && godowns.length > 0) {
                        locationDisplay = godowns.join(", ");
                    } else {
                        locationDisplay = "N/A";
                    }

                    setPresentLocation(locationDisplay);
                } else {
                    setDesignation("");
                    setDraftId("");
                    setPresentState("");
                    setPresentDistrict("");
                    setPresentLocation("");
                }
                break;

            case 'designationForEmp':
                setSelectedDesignation(value);
                setPresentLocation('');
                setEmployeeName('');
                setPostingDesignation('');
                break;

            case 'state':
                setState(value);
                setDistrict(null);
                break;
            case 'district':
                setDistrict(value);
                break;
            case "postingState":
                setPostingState(value);
                setPostingDistrict(null); // Use null instead of ''
                setToLocation(null);      // Clear the selection
                setLocationOptions([]);   // Clear the options list immediately
                break;
            case "postingDistrict":
                setPostingDistrict(value);
                setToLocation(null)
                break;
            case "postingBlock":
                setPostingBlock(value);
                break;
            case "reportingTo":
                setReportingTo(value);
                break;
            case "postingDesignation":
                setPostingDesignation(value);
                break;
            case "toLocation":
                setToLocation(selectedOption || []);
                break;
            default:
                break;


        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!employeeName) newErrors.employeeName = "Employee Name is required";
        if (!postingState) newErrors.postingState = "To State is required";
        if (!postingDistrict) newErrors.postingDistrict = "To District is required";
        if (!reportingTo) newErrors.reportingTo = "Reporting To is required";
        //if (!fromDate) newErrors.fromDate = "From Date is required";
        if (!postingDesignation) newErrors.postingDesignation = "Posting Designation is required";
        if (!toLocation) newErrors.toLocation = "To Location is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleClear = () => {
        setEmployeeName(null);
        setDesignation("");
        setDraftId("");
        setState('');
        setPresentState("");
        setPresentDistrict("");
        setPresentLocation("");
        //setDesignationForEmployees([]);
        setSelectedDesignation(null);
        setFromDate(null);
        setPostingState(null);
        setPostingDistrict(null);
        setPostingBlock(null);
        setReportingTo(null);
        setPostingDesignation(null);
        setToLocation(null);
        setErrors({});
        setRemarks("");
    };

    const handleSave = async () => {
        if (!validateForm()) return;

        // FIX: Include both TPDS and CMR types for the godown array
        const godownIds = toLocation
            .filter(loc => loc.type === "TPDS" || loc.type === "CMR")
            .map(loc => loc.value);

        const dhqLocation = toLocation.find(loc => loc.type === "DHQ");

        const payload = {
            employeeUniqueId: employeeName,
            toDesignationId: postingDesignation,
            //fromDate: format(fromDate, 'yyyy-MM-dd'),
            toStateId: postingState,
            toDistrictId: postingDistrict,
            reportingTo,
            remarks: remarks,
            auditLog: getAuditLog(),
        };

        // If godowns were selected (either TPDS or CMR), add to payload
        if (godownIds.length > 0) {
            payload.toGodownIds = godownIds;
        }

        if (dhqLocation) {
            payload.toWorkLocationId = dhqLocation.value;
        }

        try {
            await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/api/employee-transfer`,
                payload
            );
            showMessage("Employee transfer request submitted successfully.", "success");
            handleClear();
        } catch (err) {

            const message =
                err.response?.data?.error ||
                err.response?.data?.message ||
                "Something went wrong. Please try again.";

            showMessage(message, "error");

            handleClear();
        }
    };
    //console.log(fromDate);
    //console.log(format(fromDate, "yyyy-MM-dd"));
    // const selectStyles = {
    //     menuPortal: base => ({ ...base, zIndex: 9999 }),
    //     menu: base => ({ ...base, marginTop: "5px", zIndex: 9999 }),
    //     control: provided => ({ ...provided, padding: "1px" }),
    //     valueContainer: provided => ({ ...provided, padding: "3px 6px" })
    // };
    const showMessage = (message, type = "success") => {
        setPopupMessage(message);
        setPopupType(type);
        setShowPopup(true);

        setTimeout(() => {
            setShowPopup(false);
        }, 5000);
    };
    return (
        <div className="employee-transfor-maincontainer">
            <div className="employee-transfor-box">
                <h2 className="employee-transfor-heading">Employee Transfer Request</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}

                <div className="employee-transfor-structure-heading">

                    <div className="employee-transfor-maincontainer-1">
                        <div className="employee-transfor-container-part">
                            <div className={`employee-transfor-floating-label-container-2 ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="employee-transfor-container-part">
                            <div className={`employee-transfor-floating-label-container-2 ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>District</label>
                                {errors.district && <div className="error-message">{errors.district}</div>}
                            </div>
                        </div>
                    </div>

                    {/* Employee Dropdown */}
                    <div className="employee-transfor-maincontainer-1">


                        <div className="employee-transfor-container-part">
                            <div className={`employee-transfor-floating-label-container-2 ${isFocused.seletedDesignation || seletedDesignation ? "float-label" : ""}`}>
                                <Select
                                    name='designation'
                                    options={desginationsForEmployees}
                                    // This ensures that if the ID is null/empty, the Select component resets to empty
                                    value={desginationsForEmployees.find(opt => opt.value === seletedDesignation) || null}
                                    onChange={(option) => handleInputChange(option, "designationForEmp")}
                                    isClearable


                                />
                                <label><span className="required">*</span>Designation</label>
                            </div>
                        </div>


                        <div className="employee-transfor-container-part">
                            <div className={`employee-transfor-floating-label-container-2 ${isFocused.employeeName || employeeName ? "float-label" : ""}`}>
                                <Select
                                    name="employeeName"
                                    options={employees}
                                    value={employees.find(opt => opt.value === employeeName) || null}
                                    onChange={(option) => handleInputChange(option, "employeeName")}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, employeeName: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, employeeName: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Employee Name</label>
                                {errors.employeeName && <div className="error-message">{errors.employeeName}</div>}
                            </div>
                        </div>

                    </div>

                    {/* Read-only employee details */}


                    <div className="employee-transfor-maincontainer-1">

                        <div className="employee-transfor-container-part">
                            <div className="employee-transfor-floating-label-container-2">
                                <input type="text"
                                    value={presentLocation}
                                    title={presentLocation}
                                    readOnly placeholder=" " />
                                <label>Present Location</label>
                            </div>
                        </div>
                        <div className="employee-transfor-container-part">
                            {/* <div className="employee-transfor-floating-label-container-2">
                                <input type="text" value={presentDistrict} readOnly placeholder=" " />
                                <label>Present District</label>
                            </div> */}
                        </div>
                    </div>

                    {/* Transfer To Section */}
                    <div className="employee-transfor-maincontainer-1">
                        <div className="employee-transfor-container-part">
                            <div className={`employee-transfor-floating-label-container-2 ${postingState ? "float-label" : ""}`}>
                                <Select
                                    name="postingState"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === postingState) || null}
                                    onChange={(option) => handleInputChange(option, "postingState")}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>To State</label>
                                {errors.postingState && <div className="error-message">{errors.postingState}</div>}
                            </div>
                        </div>
                        <div className="employee-transfor-container-part">
                            <div className={`employee-transfor-floating-label-container-2 ${postingDistrict ? "float-label" : ""}`}>
                                <Select
                                    name="postingDistrict"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === postingDistrict) || null}
                                    onChange={(option) => handleInputChange(option, "postingDistrict")}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>To District</label>
                                {errors.postingDistrict && <div className="error-message">{errors.postingDistrict}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="employee-transfor-maincontainer-1">
                        <div className="employee-transfor-container-part">
                            <div className={`employee-transfor-floating-label-container-2 ${postingDesignation ? "float-label" : ""}`}>
                                <Select
                                    name="postingDesignation"
                                    options={designationOptions}
                                    value={designationOptions.find(opt => opt.value === postingDesignation) || null}
                                    onChange={(option) => handleInputChange(option, "postingDesignation")}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Posting Designation</label>
                                {errors.postingDesignation && <div className="error-message">{errors.postingDesignation}</div>}
                            </div>
                        </div>
                        <div className="employee-transfor-container-part">
                            <div className={`employee-transfor-floating-label-container-2 ${toLocation && toLocation.length > 0 ? "float-label" : ""}`}>
                                <Select
                                    name="toLocation"
                                    // Use the filtered function here
                                    options={getFilteredLocations()}
                                    value={toLocation}
                                    onChange={(option) => handleInputChange(option, "toLocation")}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                    isMulti={true}
                                />
                                <label><span className="required">*</span>To Location</label>
                                {errors.toLocation && <div className="error-message">{errors.toLocation}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="employee-transfor-maincontainer-1">
                        <div className="employee-transfor-container-part">
                            <div className={`employee-transfor-floating-label-container-2 ${reportingTo ? "float-label" : ""}`}>
                                <Select
                                    name="reportingTo"
                                    options={reportingOptions}
                                    value={reportingOptions.find(opt => opt.value === reportingTo) || null}
                                    onChange={(option) => handleInputChange(option, "reportingTo")}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>Reporting To</label>
                                {errors.reportingTo && <div className="error-message">{errors.reportingTo}</div>}
                            </div>
                        </div>

                        <div className="employee-transfor-container-part">
                            <div className="employee-transfor-floating-label-container-2">
                                <input type="text"
                                    value={remarks}
                                    type="text"
                                    onChange={(e) => setRemarks(e.target.value)}
                                    placeholder="Enter Reason for Transfer " />
                                <label><span className="required">*</span>Reason for Transfer</label>
                            </div>
                        </div>
                        {/* <div className="employee-transfor-container-part">
                            <div className={`employee-transfor-floating-label-container-2 ${fromDate ? "float-label" : ""}`}>
                                <DatePicker
                                    selected={fromDate}
                                    onChange={(date) => {
                                        setFromDate(date);
                                        setErrors(prev => ({ ...prev, fromDate: null }));
                                    }}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText=" "
                                    className="date-picker-input"
                                   // minDate={new Date()}
                                />
                                <label><span className="required">*</span>From Date</label>
                                {errors.fromDate && <div className="error-message">{errors.fromDate}</div>}
                            </div>
                        </div> */}

                    </div>
                    {/* <div className="employee-transfor-maincontainer-1">

                        <div className="employee-transfor-container-part">
                            <div className="employee-transfor-floating-label-container-2">
                                <input type="text"
                                    value={remarks}
                                    type="text"
                                    onChange={(e) => setRemarks(e.target.value)}
                                    placeholder="Enter Reason for Transfer " />
                                <label><span className="required">*</span>Reason for Transfer</label>
                            </div>
                        </div>
                        <div className="employee-transfor-container-part">
                            <div className="employee-transfor-floating-label-container-2">
                                <input type="text" value={presentDistrict} readOnly placeholder=" " />
                                <label>Present District</label>
                            </div>
                        </div>
                    </div> */}
                    {/* <div>
                        <table>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>State</th>
                                    <th>District</th>
                                    <th>Working Location</th>
                                    <th>Posting Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}

                    {/* Buttons */}
                    <div className="employee-transfor-btn-div">
                        <button type="button" className="employee-transfor-cancel" onClick={handleClear}>
                            Cancel
                        </button>
                        <button type="button" className="employee-transfor-clear" onClick={handleClear}>
                            Clear
                        </button>
                        <button type="button" className="employee-transfor-btn" onClick={handleSave}>
                            Save
                        </button>
                    </div>
                    {showPopup && (
                        <div className="confirm-overlay">
                            <div className={`popup-box ${popupType}`}>
                                <p>{popupMessage}</p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EmployeeTransfer;
